import {z} from 'zod'

export const GetAllCountriesRequestSchema = z.void()

export const GetAllCountriesResponseSchema = z.array(
  z.object({
    id: z.number(),
    code: z.string(),
    name: z.string(),
  })
)

export type GetAllCountriesRequest = z.infer<typeof GetAllCountriesRequestSchema>
export type GetAllCountriesResponse = z.infer<typeof GetAllCountriesResponseSchema>
